export default __webpack_public_path__ + "static/media/a011-startup-1.e8787cc4.svg";